import styled from 'styled-components';
import ButtonProps from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';

const KeyLetters = styled.div<ButtonProps>`
  margin-right: ${22 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${43 * Screen.widthRatio}px;
  left: ${42 * Screen.widthRatio}px;
  top: ${-42.5 * Screen.widthRatio}px;
  margin-right: ${22 * Screen.widthRatio}px;
  position: relative;
  width: ${76 * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? 'black ' : Colors['grey'])};
  text-align: center;
  justify-content: center;
  background-color: ${(props) =>
    props.focused ? Colors['key'] : Colors['keyBg']};
  font-size: ${24 * Screen.widthRatio}px;
  font-family: ${Fonts['regular']};
  border-radius: ${5 * Screen.widthRatio}px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.3);
  line-height ${42 * Screen.widthRatio}px;
`;

export default KeyLetters;
